<template>
    <div class="user-profile-tab-profile">
        <div class="row responsive-tablet-col-1">
            <div class="col-md-3">
                <div class="user-profile-tab-profile-stats transition-3s">
                    <h1>Stats</h1>
                    <ul class="d-flex flex-wrap justify-content-between">
                        <li>
                            <span class="count">331</span>
                            <span class="title">reputation</span>
                        </li>
                        <li>
                            <span class="count">23k</span>
                            <span class="title">reached</span>
                        </li>
                        <li>
                            <span class="count">52</span>
                            <span class="title">answers</span>
                        </li>
                        <li>
                            <span class="count">8</span>
                            <span class="title">questions</span>
                        </li>
                        
                        <li class="rank-badge w-full">
                            <el-icon class="d-block"><Trophy /></el-icon>
                            <p>top <b>70%</b> this year</p>
                        </li>
                    </ul>
                </div>
            </div>

            <div class="col-md-9">
                <div class="user-profile-tab-profile-about">
                    <h1>About</h1>
                    <p>Hi, My name Is Tanbir Ahmod. I'm a fully professional Full-stack WordPress Developer with over 4+ years of experience. I'm a self-taught developer, and it's something I am incredibly passionate about. I'm a dedicated to my work believe in working hard for my clients, so they get the most unique and eye-catching developer while remaining professional.</p>

                    <user-profile-tags :items="profileTags" :showPostParcent="true" />

                    <user-profile-badges />

                    <top-posts />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { Trophy } from '@element-plus/icons-vue'
import UserProfileBadges from '../pieces/UserProfile/_UserProfileBadges.vue'
import UserProfileTags from '../pieces/UserProfile/_UserProfileTags.vue'
import TopPosts from '../pieces/UserProfile/TopPosts.vue'

export default {
    name: 'UserProfileTabDefault',
    components: {
        Trophy,
        UserProfileBadges,
        UserProfileTags,
        TopPosts
    },
    data(){
        return {

            profileTags: [
                {
                    id: 1,
                    title: 'glit',
                    score: '58,420',
                    posts: '413',
                    parcent: '21'
                },
                {
                    id: 2,
                    title: 'html',
                    score: '24,422',
                    posts: '4332',
                    parcent: '23'
                },
                {
                    id: 3,
                    title: 'c++',
                    score: '34,422',
                    posts: '432',
                    parcent: '24'
                },
                {
                    id: 4,
                    title: 'c+',
                    score: '3,332',
                    posts: '453',
                    parcent: '19'
                },
                {
                    id: 5,
                    title: 'stl',
                    score: '332',
                    posts: '43',
                    parcent: '5'
                },
                {
                    id: 6,
                    title: 'pointers',
                    score: '3,204',
                    posts: '22',
                    parcent: '5'
                },
                {
                    id: 7,
                    title: 'arrays',
                    score: '10,204',
                    posts: '224',
                    parcent: '22'
                }
            ]
        }
    }
}
</script>